import React from "react";

import {borderColour} from "../../../../style/styleConsts";

export const OriginBar = () => (
    <div style={{backgroundColor: borderColour, width: 1, height: 14, position: "absolute", left: "50%", top: -2}}/>
);